import React, { forwardRef } from "react";
import { Input, Label } from "reactstrap";

interface TableSearchProps {
  value: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerClassName: string;
}

// forwardRef provides `ref` as the second argument
const TableSearch = forwardRef<HTMLInputElement, TableSearchProps>(
  ({ label, value, onChange, containerClassName }, ref) => {
    return (
      <div id="basic-12_filter" className={containerClassName}>
        <Label className="me-2">{label}:</Label>
        <Input onChange={onChange} type="search" value={value} innerRef={ref} />
      </div>
    );
  }
);

export default TableSearch;
